import Vue from 'vue'

// axios
import axios from 'axios'
import router from '@/router'
import { clearAuthStorage } from '@/auth/session'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://app.mymunshi.in'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: API_BASE_URL,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

axiosIns.interceptors.response.use(
  response => {
    const message = response?.data?.message
    if (message === 'authorization_failed' || message === 'session_expired') {
      clearAuthStorage()
      if (router.currentRoute?.name !== 'auth-login') {
        router.push({ name: 'auth-login' })
      }
    }
    return response
  },
  error => {
    const message = error?.response?.data?.message
    if (message === 'authorization_failed' || message === 'session_expired') {
      clearAuthStorage()
      if (router.currentRoute?.name !== 'auth-login') {
        router.push({ name: 'auth-login' })
      }
    }
    return Promise.reject(error)
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
